@if (isLoading) {
  <aw-spinner [fullScreen]="false"></aw-spinner>
}

@if (showHeading) {
  <aw-divider
    [inset]="false"
    [middleInset]="false"
    [subTitle]="'API Access'"
    [altColor]="true"
  >
  </aw-divider>
}

@if (errorMessage) {
  <div class="error-message">
    <p>{{ errorMessage }}</p>
  </div>
} @else {
  <div class="table-form-container" [ngClass]="'light-theme'">
    <div>
      <aw-search
        [(ngModel)]="searchValue"
        (ngModelChange)="onSearchTable(searchValue)"
        ariaLabel="search-api-access"
        [placeholder]="'Search'"
      >
        <mat-icon [svgIcon]="'search'" position="prefix"></mat-icon>
      </aw-search>
    </div>

    <Button
      AwButton
      [disable]="disableChangeAssignment"
      (click)="openChangeAssignmentDialog = true"
    >Change Assignment</Button>
  </div>

  <aw-table
    [columnsDefinition]="columnsDefinition"
    [tableData]="apiAccessTableData()"
    [sortDisabled]="false"
    (checkboxList)="checkBoxActionHandler($event)"
  >
  </aw-table>

  <aw-dialog
    [visible]="openChangeAssignmentDialog"
    [formFieldsData]="changeAssignmentFormFields()"
    [dialogOptions]="changeAssignmentDialogOptions()"
    (primaryAction)="changeAssignmentFormSubmit($event)"
    (secondaryAction)="dialogFormCloseHandler()"
    ariaLabel="Change table assignment"
  >
  </aw-dialog>
}
